import i18n from "i18n";
i18n.setDefaultNamespace('common');

export const currentUserMessages = {
  profileUpdate: i18n.t('notifications.currentUser.profileUpdate')
};
